import React from 'react';
import azim from '../files/azim-width.png';
import resume from '../files/Faijul_Azim_Full_stack_Developer_Resume.pdf'
import CV from '../files/Faijul_Azim_Developer_CV.pdf'
import download from '../files/download.png';
import open from '../files/open.png';


function About() {
    return (
        <div id='about' className='lg:flex bg-[#242526] lg:h-[650px]'>
            <div data-aos="flip-right" data-aos-duration="2000" className='lg:w-5/12   flex items-center justify-center lg:grid content-center lg:ml-10'>
                <div>
                    <img className='bannerImg  shadow-md shadow-[#17A875] rounded-full lg:w-96 w-48  mt-12 lg:mt-0' src={azim} alt='' />
                    <p className='text-center text-white italic mt-8'>" Code to solve problems, <br /> develop to make live easier. " <br /> - Faijul Azim</p>
                </div>
            </div>
            <div data-aos="fade-up" data-aos-duration="2000" className='lg:w-7/12 lg:grid content-center lg:mr-28 p-6'>
                <h2 className='lg:text-5xl text-3xl font-bold text-[#17A875] mb-4'> About </h2>
                <p className='text-white mb-8 tracking-wider'>
                    Hi, I am Azim. I am a Full stack Developer.<br></br> I am passionate about building excellent web applications that provides the best user experience. I am a hard-working and quality-focused web developer with good problem-solving skills. Love to do something new with the latest technology.
                    <p className='my-5'>
                        <p className='text-3xl text-[#17A875] font-bold'>Experience</p>
                        <p className='text-xl  leading-8'>
                            <a href="https://drive.google.com/file/d/1dw8VbtGU6SLMP2QSxXhhy6HsXLE7Ehb0/view?usp=sharing" target='_blank' rel="noreferrer">
                                Position: MERN stack developer <img className='lg:w-4 w-3  ml-1 inline' src={open} alt='' />
                            </a>
                        </p>
                        <p>Company: <a href="https://dsl.sg" target='_blank' rel="noreferrer">DS Legends Pte. Ltd, Midview city, Singapore. <img className='lg:w-4 w-3  ml-1 inline' src={open} alt='' /></a></p>
                        <p>Type: Remote & Internship</p>
                        <p>Duration: 1 Oct 2022 – 31 Jan 2023</p>
                        <p>Main Responsibilities - Building new features, attractive UI, and API integration in React while prioritizing clean and
                            reusable code. Managing GitHub, team collaboration, multitasking across multiple projects.</p>

                    </p>
                    you can know more about me from my CV/resume.
                </p>
                <div className='flex'>
                    <a className='mr-5' href={CV} download={true}><button className='btn bg-[#17A875] hover:border-[#17A875] text-xs rounded-sm lg:w-36 w-32 btn-sm h-10  text-white font-light lg:text-lg'>CV <img className='w-6 ml-4' src={download} alt='' /></button></a>

                    <a href={resume} download={true}><button className='btn bg-[#17A875] hover:border-[#17A875] text-xs rounded-sm lg:w-36 w-32 btn-sm h-10  text-white font-light lg:text-lg '>Resume <img className='w-6 ml-4' src={download} alt='' /></button></a>

                </div>

            </div>
            {/* <input type="checkbox" id="my-modal-6" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box lg:w-4/12 w-10/12 max-w-5xl bg-[#18191A] border-2 border-[#17A875] text-white">
                    <label for="my-modal-6" className="btn btn-sm border-2 border-[#18191A] btn-circle bg-[#17A875]   absolute right-2 top-2">✕</label>
                    <img  src='https://i.ibb.co/xGnFWT3/image.png' alt='resume'/>
                    <a href={pdf} download={true}><button className='btn  bg-[#17A875]  text-xs rounded-sm lg:w-48 w-36 btn-sm  text-white font-light  mt-4'>Download resume</button></a>

                </div>
            </div> */}
        </div>
    )
}

export default About;
